import React from 'react';
import api from 'api';
import { useAlerts, useLoaders, useResource } from 'hooks';
import { validateEvent } from 'validations/events';

const useEventVideos = ({ id, ...props }) => {
	const { showLoading, hideLoading } = useLoaders();
	const { showAlertError, showAlertSuccess } = useAlerts();

	const {
		resourceId: eventId,
		isLoading,
		isLoaded,
		isEmpty,
		isEditing,
		isValid,
		resource: eventVideo,
		resources: eventVideos,
		findOne: findEventVideo,
		findMany: findEventVideos,
		update: updateEventVideo,
		create: createEventVideo,
		save: saveEventVideo,
		destroy: deleteEventVideo,
		setResource: setEventVideo,
		handleChange,
		clearResource,
		handleChangePage,
		uploadFile,
		deleteFile,
		reload: reloadEventVideo,
		reloadMany: reloadEventsVideos,
		query,
		page,
		paginate,
		numPages,
		perPage,
		totalCount,
		sortKey,
		sortDirection,
		handleSort
	} = useResource({
		id: id,
		url: '/api/v1/admin/event_videos',
		name: 'event_video'
	});

	const resortEventVideos = (event) => {
		const sorted = event.event_videos.map((item) => ({
			id: item.id,
			position: item.position
		}));
		api.post(`/api/v1/admin/event_videos/${event.id}/resort`, {
			event_videos: sorted
		});
		return sorted;
	};

	return {
		eventId,
		isLoading,
		isLoaded,
		isEmpty,
		isEditing,
		isValid,
		eventVideo,
		eventVideos,
		findEventVideo,
		findEventVideos,
		saveEventVideo,
		updateEventVideo,
		createEventVideo,
		deleteEventVideo,
		uploadFile,
		deleteFile,
		handleChange,
		clearResource,
		handleChangePage,
		query,
		page,
		paginate,
		numPages,
		perPage,
		totalCount,
		sortKey,
		sortDirection,
		handleSort,
		reloadEventVideo,
		reloadEventsVideos,
		setEventVideo,
		resortEventVideos
	};
};

export default useEventVideos;
